const cascaderLocale = {
  pleaseSelect: "Please select"
};
export {
  cascaderLocale
};
//# sourceMappingURL=en_US.js.map
